/**
 * EDG links were explicitly brought to the front in the old JointJS renderer
 * (`createEDGLink(...).toFront()`), so MERODE markers sit on top of object
 * rectangles instead of being hidden under them. React Flow renders edges below
 * nodes by default; this z-index restores the old EDG stacking.
 */
export const EDG_EDGE_Z_INDEX = 1001;
export const SELECTED_EDG_EDGE_Z_INDEX = EDG_EDGE_Z_INDEX + 1;

export function withEdgEdgeZIndex<T extends object>(
  edge: T,
  selected = false
): T & { zIndex: number } {
  return { ...edge, zIndex: selected ? SELECTED_EDG_EDGE_Z_INDEX : EDG_EDGE_Z_INDEX };
}
